import { render, staticRenderFns } from "./CustomerBatchUploadView.vue?vue&type=template&id=8480a3e6&"
import script from "./CustomerBatchUploadView.vue?vue&type=script&lang=ts&"
export * from "./CustomerBatchUploadView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports